import { Types } from "../actions/PlannedMaintenanceUpdateActions";

const initialState = {
    excelList: [],
    uploadResponse: {},
};

export const PlannedMaintenanceUpdate = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_EXCEL_LIST_FOR_UPDATE_DATE:
            return {
                ...state,
                excelList: action.payload || state.excelList,
            };
        case Types.POST_UPLOAD_FILE_FOR_UPDATE_DATE:
            return {
                ...state,
                uploadResponse: action.payload || state.uploadResponse,
            };
        default:
            return state;
    }
};
